var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Dialog from "@/components/common/dialog/Dialog.vue";
import Button from "@/components/ui/button/Button.vue";
import Select from "@/components/ui/select/Select.vue";
import { StepIndicator } from "@/components/ui/step-indicator";
import { sendChangeRequest } from "@/views/objectives-report/api/changes";
import { TriangleAlertIcon } from "lucide-vue-next";
import { computed, ref, watch } from "vue";
import { BULK_EDIT_STEPS, BULK_EDIT_STEPS_LIST } from "./types";
import { useBulkEdit } from "./useBulkEdit";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BulkEditDialod',
    props: {
        distributors: { type: Array, required: true },
        dataRows: { type: Array, required: true },
        objectives: { type: Array, required: true },
        fields: { type: Object, required: true },
        period: { type: Object, required: true }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        // Dialog ref
        const dialogRef = ref();
        // Current step
        const currentStep = ref(BULK_EDIT_STEPS_LIST[0]);
        // Result state
        const result = ref(null);
        // Step configurations
        const stepsForStepper = [
            {
                key: BULK_EDIT_STEPS.SELECT_DISTRIBUTOR,
                label: "Seleccionar<br>Distribuidor",
                icon: `<svg width="36" height="29" viewBox="0 0 36 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.4 4.53125C5.4 3.81019 5.68446 3.11867 6.19081 2.6088C6.69716 2.09894 7.38392 1.8125 8.1 1.8125C8.81608 1.8125 9.50284 2.09894 10.0092 2.6088C10.5155 3.11867 10.8 3.81019 10.8 4.53125C10.8 5.25231 10.5155 5.94383 10.0092 6.4537C9.50284 6.96356 8.81608 7.25 8.1 7.25C7.38392 7.25 6.69716 6.96356 6.19081 6.4537C5.68446 5.94383 5.4 5.25231 5.4 4.53125ZM12.6 4.53125C12.6 3.32949 12.1259 2.17695 11.282 1.32717C10.4381 0.477398 9.29347 0 8.1 0C6.90653 0 5.76193 0.477398 4.91802 1.32717C4.07411 2.17695 3.6 3.32949 3.6 4.53125C3.6 5.73301 4.07411 6.88555 4.91802 7.73533C5.76193 8.5851 6.90653 9.0625 8.1 9.0625C9.29347 9.0625 10.4381 8.5851 11.282 7.73533C12.1259 6.88555 12.6 5.73301 12.6 4.53125ZM18 9.0625C18.9548 9.0625 19.8705 9.44442 20.5456 10.1242C21.2207 10.8041 21.6 11.7261 21.6 12.6875C21.6 13.6489 21.2207 14.5709 20.5456 15.2508C19.8705 15.9306 18.9548 16.3125 18 16.3125C17.0452 16.3125 16.1295 15.9306 15.4544 15.2508C14.7793 14.5709 14.4 13.6489 14.4 12.6875C14.4 11.7261 14.7793 10.8041 15.4544 10.1242C16.1295 9.44442 17.0452 9.0625 18 9.0625ZM18 18.125C18.7091 18.125 19.4113 17.9844 20.0665 17.7111C20.7216 17.4378 21.3169 17.0373 21.8184 16.5324C22.3198 16.0275 22.7176 15.428 22.9889 14.7683C23.2603 14.1086 23.4 13.4016 23.4 12.6875C23.4 11.9734 23.2603 11.2664 22.9889 10.6067C22.7176 9.94695 22.3198 9.34753 21.8184 8.84261C21.3169 8.33769 20.7216 7.93717 20.0665 7.66391C19.4113 7.39065 18.7091 7.25 18 7.25C17.2909 7.25 16.5887 7.39065 15.9335 7.66391C15.2784 7.93717 14.6831 8.33769 14.1816 8.84261C13.6802 9.34753 13.2824 9.94695 13.011 10.6067C12.7397 11.2664 12.6 11.9734 12.6 12.6875C12.6 13.4016 12.7397 14.1086 13.011 14.7683C13.2824 15.428 13.6802 16.0275 14.1816 16.5324C14.6831 17.0373 15.2784 17.4378 15.9335 17.7111C16.5887 17.9844 17.2909 18.125 18 18.125ZM14.6981 21.75H21.2962C24.345 21.75 26.8312 24.1572 26.9887 27.1875H9.00562C9.16313 24.1572 11.6494 21.75 14.6981 21.75ZM14.6981 19.9375C10.5581 19.9375 7.2 23.3189 7.2 27.4877C7.2 28.3203 7.86937 29 8.70187 29H27.3037C28.1306 29 28.8056 28.326 28.8056 27.4877C28.8 23.3189 25.4419 19.9375 21.3019 19.9375H14.7037H14.6981ZM28.8 1.8125C29.5161 1.8125 30.2028 2.09894 30.7092 2.6088C31.2155 3.11867 31.5 3.81019 31.5 4.53125C31.5 5.25231 31.2155 5.94383 30.7092 6.4537C30.2028 6.96356 29.5161 7.25 28.8 7.25C28.0839 7.25 27.3972 6.96356 26.8908 6.4537C26.3845 5.94383 26.1 5.25231 26.1 4.53125C26.1 3.81019 26.3845 3.11867 26.8908 2.6088C27.3972 2.09894 28.0839 1.8125 28.8 1.8125ZM28.8 9.0625C29.9935 9.0625 31.1381 8.5851 31.982 7.73533C32.8259 6.88555 33.3 5.73301 33.3 4.53125C33.3 3.32949 32.8259 2.17695 31.982 1.32717C31.1381 0.477398 29.9935 0 28.8 0C27.6065 0 26.4619 0.477398 25.618 1.32717C24.7741 2.17695 24.3 3.32949 24.3 4.53125C24.3 5.73301 24.7741 6.88555 25.618 7.73533C26.4619 8.5851 27.6065 9.0625 28.8 9.0625ZM29.7 12.6875C32.1862 12.6875 34.2 14.7152 34.2 17.2188C34.2 17.7172 34.605 18.125 35.1 18.125C35.595 18.125 36 17.7172 36 17.2188C36 13.7127 33.1819 10.875 29.7 10.875H24.975C25.1213 11.4527 25.2 12.0645 25.2 12.6875H29.7ZM10.8 12.6875C10.8 12.0645 10.8787 11.4527 11.025 10.875H6.3C2.81812 10.875 0 13.7127 0 17.2188C0 17.7172 0.405 18.125 0.9 18.125C1.395 18.125 1.8 17.7172 1.8 17.2188C1.8 14.7152 3.81375 12.6875 6.3 12.6875H10.8Z"/>
    </svg>`,
            },
            {
                key: BULK_EDIT_STEPS.SELECT_OBJECTIVE,
                label: "Seleccionar<br>Objetivos",
                icon: `<svg width="30" height="29" viewBox="0 0 30 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M28.125 14.5C28.125 11.1351 26.7422 7.90795 24.2808 5.52858C21.8194 3.14921 18.481 1.8125 15 1.8125C11.519 1.8125 8.18064 3.14921 5.71922 5.52858C3.25781 7.90795 1.875 11.1351 1.875 14.5C1.875 17.8649 3.25781 21.092 5.71922 23.4714C8.18064 25.8508 11.519 27.1875 15 27.1875C18.481 27.1875 21.8194 25.8508 24.2808 23.4714C26.7422 21.092 28.125 17.8649 28.125 14.5ZM0 14.5C0 10.6544 1.58035 6.96623 4.3934 4.24695C7.20644 1.52767 11.0218 0 15 0C18.9782 0 22.7936 1.52767 25.6066 4.24695C28.4196 6.96623 30 10.6544 30 14.5C30 18.3456 28.4196 22.0338 25.6066 24.753C22.7936 27.4723 18.9782 29 15 29C11.0218 29 7.20644 27.4723 4.3934 24.753C1.58035 22.0338 0 18.3456 0 14.5ZM15 21.75C16.9891 21.75 18.8968 20.9862 20.3033 19.6265C21.7098 18.2669 22.5 16.4228 22.5 14.5C22.5 12.5772 21.7098 10.7331 20.3033 9.37348C18.8968 8.01384 16.9891 7.25 15 7.25C13.0109 7.25 11.1032 8.01384 9.6967 9.37348C8.29018 10.7331 7.5 12.5772 7.5 14.5C7.5 16.4228 8.29018 18.2669 9.6967 19.6265C11.1032 20.9862 13.0109 21.75 15 21.75ZM15 5.4375C17.4864 5.4375 19.871 6.3923 21.6291 8.09184C23.3873 9.79139 24.375 12.0965 24.375 14.5C24.375 16.9035 23.3873 19.2086 21.6291 20.9082C19.871 22.6077 17.4864 23.5625 15 23.5625C12.5136 23.5625 10.129 22.6077 8.37087 20.9082C6.61272 19.2086 5.625 16.9035 5.625 14.5C5.625 12.0965 6.61272 9.79139 8.37087 8.09184C10.129 6.3923 12.5136 5.4375 15 5.4375ZM15 16.3125C15.4973 16.3125 15.9742 16.1215 16.3258 15.7816C16.6775 15.4417 16.875 14.9807 16.875 14.5C16.875 14.0193 16.6775 13.5583 16.3258 13.2184C15.9742 12.8785 15.4973 12.6875 15 12.6875C14.5027 12.6875 14.0258 12.8785 13.6742 13.2184C13.3225 13.5583 13.125 14.0193 13.125 14.5C13.125 14.9807 13.3225 15.4417 13.6742 15.7816C14.0258 16.1215 14.5027 16.3125 15 16.3125ZM15 10.875C15.9946 10.875 16.9484 11.2569 17.6516 11.9367C18.3549 12.6166 18.75 13.5386 18.75 14.5C18.75 15.4614 18.3549 16.3834 17.6516 17.0633C16.9484 17.7431 15.9946 18.125 15 18.125C14.0054 18.125 13.0516 17.7431 12.3483 17.0633C11.6451 16.3834 11.25 15.4614 11.25 14.5C11.25 13.5386 11.6451 12.6166 12.3483 11.9367C13.0516 11.2569 14.0054 10.875 15 10.875Z"/>
    </svg>`,
            },
            {
                key: BULK_EDIT_STEPS.EDIT_FIELDS,
                label: "Modificar<br>KPIs",
                icon: `<svg width="22" height="29" viewBox="0 0 22 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3333 27.1875H3.66667C2.6526 27.1875 1.83333 26.3775 1.83333 25.375V3.625C1.83333 2.62246 2.6526 1.8125 3.66667 1.8125H11V8.15625C11 9.65723 12.2318 10.875 13.75 10.875H20.1667V25.375C20.1667 26.3775 19.3474 27.1875 18.3333 27.1875ZM13.75 9.0625C13.2458 9.0625 12.8333 8.65469 12.8333 8.15625V1.84082C12.9938 1.88047 13.1427 1.95977 13.2573 2.07871L19.8974 8.64336C20.0177 8.76231 20.0979 8.90391 20.138 9.0625H13.75ZM3.66667 0C1.64427 0 0 1.62559 0 3.625V25.375C0 27.3744 1.64427 29 3.66667 29H18.3333C20.3557 29 22 27.3744 22 25.375V9.2834C22 8.56406 21.7078 7.87305 21.1922 7.36328L14.5578 0.798633C14.0422 0.288867 13.3432 0 12.6156 0H3.66667ZM6.41667 14.5C5.9125 14.5 5.5 14.9078 5.5 15.4062C5.5 15.9047 5.9125 16.3125 6.41667 16.3125H15.5833C16.0875 16.3125 16.5 15.9047 16.5 15.4062C16.5 14.9078 16.0875 14.5 15.5833 14.5H6.41667ZM6.41667 18.125C5.9125 18.125 5.5 18.5328 5.5 19.0312C5.5 19.5297 5.9125 19.9375 6.41667 19.9375H15.5833C16.0875 19.9375 16.5 19.5297 16.5 19.0312C16.5 18.5328 16.0875 18.125 15.5833 18.125H6.41667ZM6.41667 21.75C5.9125 21.75 5.5 22.1578 5.5 22.6562C5.5 23.1547 5.9125 23.5625 6.41667 23.5625H15.5833C16.0875 23.5625 16.5 23.1547 16.5 22.6562C16.5 22.1578 16.0875 21.75 15.5833 21.75H6.41667Z"/>
    </svg>`,
            },
            {
                key: BULK_EDIT_STEPS.REVIEW_CHANGES,
                label: "Revisar<br>Cambios",
                icon: `<svg width="29" height="29" viewBox="0 0 29 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 1.8125C17.8649 1.8125 21.092 3.14921 23.4714 5.52858C25.8508 7.90795 27.1875 11.1351 27.1875 14.5C27.1875 17.8649 25.8508 21.092 23.4714 23.4714C21.092 25.8508 17.8649 27.1875 14.5 27.1875C11.1351 27.1875 7.90795 25.8508 5.52858 23.4714C3.14921 21.092 1.8125 17.8649 1.8125 14.5C1.8125 11.1351 3.14921 7.90795 5.52858 5.52858C7.90795 3.14921 11.1351 1.8125 14.5 1.8125ZM14.5 29C18.3456 29 22.0338 27.4723 24.753 24.753C27.4723 22.0338 29 18.3456 29 14.5C29 10.6544 27.4723 6.96623 24.753 4.24695C22.0338 1.52767 18.3456 0 14.5 0C10.6544 0 6.96623 1.52767 4.24695 4.24695C1.52767 6.96623 0 10.6544 0 14.5C0 18.3456 1.52767 22.0338 4.24695 24.753C6.96623 27.4723 10.6544 29 14.5 29ZM20.5775 11.515C20.9287 11.1639 20.9287 10.5861 20.5775 10.235C20.2264 9.88379 19.6486 9.88379 19.2975 10.235L12.6875 16.8449L9.70254 13.86C9.35137 13.5088 8.77363 13.5088 8.42246 13.86C8.07129 14.2111 8.07129 14.7889 8.42246 15.14L12.0475 18.765C12.3986 19.1162 12.9764 19.1162 13.3275 18.765L20.5775 11.515Z"/>
    </svg>`,
            },
            {
                key: BULK_EDIT_STEPS.CONFIRMATION,
                label: "Enviar<br>Validación",
                icon: `<svg width="36" height="29" viewBox="0 0 29 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M28.9784 2.08498C29.086 1.3995 28.7858 0.708357 28.2137 0.317464C27.6415 -0.0734301 26.8938 -0.107421 26.2877 0.238152L0.910249 14.7409C0.309801 15.0808 -0.0414046 15.7323 0.00391223 16.4234C0.0492291 17.1146 0.479739 17.7207 1.11418 17.987L9.06162 21.2954V26.564C9.06162 27.9123 10.1549 29 11.4974 29C12.2395 29 12.9362 28.6658 13.4007 28.0879L16.3916 24.3489H16.3973L22.8663 27.0455C23.3817 27.2608 23.9652 27.2268 24.4524 26.9549C24.9395 26.683 25.2737 26.2014 25.3587 25.6519L28.984 2.08498H28.9784ZM14.6469 23.6238L11.9846 26.9549C11.8656 27.1022 11.6843 27.1872 11.4974 27.1872C11.1519 27.1872 10.8743 26.9096 10.8743 26.564V22.0489L14.6469 23.6238ZM17.0884 22.6777L11.6164 20.3947L26.8541 3.98847L23.563 25.3743L17.094 22.6777H17.0884ZM25.5173 2.75913L9.83201 19.6525L1.81092 16.3101L25.5173 2.75913Z"/>
    </svg>`,
            },
        ];
        // Initialize bulk edit service
        const bulkEditService = useBulkEdit({
            period: props.period,
        });
        // Editable columns state
        const editableColumns = ref([]);
        // Distributor options
        const distributorOptions = computed(() => {
            return props.distributors.map((d) => ({ label: d.label, value: d.value }));
        });
        // Objective options
        const objectiveOptions = computed(() => {
            return props.objectives.map((obj) => ({
                label: obj.name,
                value: obj.id,
            }));
        });
        // Selected objective
        const selectedObjective = computed(() => {
            const objectiveId = bulkEditService.formData.value.objectiveId;
            return props.objectives.find((obj) => obj.id === objectiveId);
        });
        const selectedObjectiveName = computed(() => { var _a; return ((_a = selectedObjective.value) === null || _a === void 0 ? void 0 : _a.name) || ""; });
        // Expected row count
        const expectedRowCount = computed(() => {
            const distributor = bulkEditService.formData.value.distributor;
            if (!distributor)
                return 0;
            if (!props.dataRows)
                return 0;
            const rows = props.dataRows.filter((row) => row.distribuidor === distributor);
            return rows.length;
        });
        // Delegacion validation
        const delegacionLineCount = computed(() => bulkEditService.getLineCount(bulkEditService.formData.value.delegacionZonaDeVentas));
        const isDelegacionValid = computed(() => {
            const value = bulkEditService.formData.value.delegacionZonaDeVentas;
            if (!value.trim())
                return false;
            return bulkEditService.validateColumnLineCount(value, expectedRowCount.value);
        });
        // Update column validation when values change
        watch(() => editableColumns.value.map((col) => col.value), () => {
            editableColumns.value.forEach((col) => {
                col.lineCount = bulkEditService.getLineCount(col.value);
                col.isValid = col.lineCount === 0 || bulkEditService.validateColumnLineCount(col.value, expectedRowCount.value);
            });
        }, { deep: true });
        // Validation
        const hasValidationErrors = computed(() => {
            if (delegacionLineCount.value > 0 && !isDelegacionValid.value)
                return true;
            return editableColumns.value.some((col) => !col.isValid && col.lineCount > 0);
        });
        const fieldsBeingModified = computed(() => {
            return editableColumns.value.filter((col) => col.value.trim() !== "");
        });
        // Review step data parsing
        const activeColumns = computed(() => {
            return editableColumns.value.filter((col) => col.value.trim() !== "");
        });
        const previewData = computed(() => {
            const delegacionValue = bulkEditService.formData.value.delegacionZonaDeVentas;
            if (!delegacionValue.trim())
                return [];
            const delegacionLines = delegacionValue.split("\n").filter((line) => line.trim() !== "");
            return delegacionLines.map((delegacion, index) => {
                const fields = {};
                activeColumns.value.forEach((column) => {
                    const columnLines = column.value.split("\n").filter((line) => line.trim() !== "");
                    fields[column.field.key] = columnLines[index] || "";
                });
                return {
                    delegacion: delegacion.trim(),
                    fields,
                };
            });
        });
        const previewErrors = computed(() => {
            const errors = [];
            // Check for line count mismatches
            const delegacionLineCount = bulkEditService.getLineCount(bulkEditService.formData.value.delegacionZonaDeVentas);
            activeColumns.value.forEach((column) => {
                if (column.lineCount !== delegacionLineCount) {
                    errors.push(`La columna "${column.field.label}" tiene ${column.lineCount} filas pero se esperan ${delegacionLineCount}`);
                }
            });
            return errors;
        });
        // Total affected fields for alert message
        const totalAffectedFields = computed(() => {
            return previewData.value.length * activeColumns.value.length;
        });
        // Navigation utilities
        const getCurrentStepIndex = () => BULK_EDIT_STEPS_LIST.indexOf(currentStep.value);
        const isNavigableStep = (step) => step !== BULK_EDIT_STEPS.LOADING && step !== BULK_EDIT_STEPS.RESULT;
        // Navigation helpers
        const showStepper = computed(() => isNavigableStep(currentStep.value));
        const showPrevButton = computed(() => {
            const currentIndex = getCurrentStepIndex();
            // Show prev button if not on first step and on a navigable step
            return currentIndex > 0 && isNavigableStep(currentStep.value);
        });
        const showCancelButton = computed(() => {
            return currentStep.value !== BULK_EDIT_STEPS.LOADING;
        });
        const showNextButton = computed(() => {
            const currentIndex = getCurrentStepIndex();
            // Show next button if not on confirmation step and on a navigable step
            return currentIndex >= 0 && currentStep.value !== BULK_EDIT_STEPS.CONFIRMATION && isNavigableStep(currentStep.value);
        });
        const showConfirmButton = computed(() => {
            return currentStep.value === BULK_EDIT_STEPS.CONFIRMATION;
        });
        const showRetryButton = computed(() => {
            var _a;
            return currentStep.value === BULK_EDIT_STEPS.RESULT && !((_a = result.value) === null || _a === void 0 ? void 0 : _a.success);
        });
        const showBackToEditButton = computed(() => {
            var _a;
            return currentStep.value === BULK_EDIT_STEPS.RESULT && !((_a = result.value) === null || _a === void 0 ? void 0 : _a.success);
        });
        const canProceedToNext = computed(() => {
            switch (currentStep.value) {
                case BULK_EDIT_STEPS.SELECT_DISTRIBUTOR:
                    return !!bulkEditService.formData.value.distributor;
                case BULK_EDIT_STEPS.SELECT_OBJECTIVE:
                    return !!bulkEditService.formData.value.objectiveId;
                case BULK_EDIT_STEPS.EDIT_FIELDS:
                    return !hasValidationErrors.value && fieldsBeingModified.value.length > 0;
                case BULK_EDIT_STEPS.REVIEW_CHANGES:
                    return previewErrors.value.length === 0 && previewData.value.length > 0;
                default:
                    return false;
            }
        });
        const canConfirm = computed(() => {
            return bulkEditService.formData.value.justification.trim().length > 0;
        });
        const isStepCompleted = (step) => {
            const currentIndex = getCurrentStepIndex();
            const stepIndex = BULK_EDIT_STEPS_LIST.indexOf(step);
            return stepIndex < currentIndex;
        };
        // Initialize editable columns when objective is selected
        watch(() => bulkEditService.formData.value.objectiveId, (objectiveId) => {
            if (objectiveId && selectedObjective.value) {
                const fields = selectedObjective.value.getSourceFields(props.fields);
                editableColumns.value = fields.map((field) => ({
                    field,
                    value: "",
                    lineCount: 0,
                    isValid: true,
                }));
            }
        });
        // Methods
        const open = () => {
            var _a;
            // Reset state
            currentStep.value = BULK_EDIT_STEPS.SELECT_DISTRIBUTOR;
            result.value = null;
            bulkEditService.formData.value = {
                distributor: null,
                objectiveId: null,
                delegacionZonaDeVentas: "",
                columns: [],
                justification: "",
            };
            editableColumns.value = [];
            return ((_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.open()) || Promise.resolve({ action: "close" });
        };
        const handleNext = () => {
            if (!canProceedToNext.value)
                return;
            const currentIndex = getCurrentStepIndex();
            if (currentIndex >= 0 && currentIndex < BULK_EDIT_STEPS_LIST.length - 1) {
                currentStep.value = BULK_EDIT_STEPS_LIST[currentIndex + 1];
            }
        };
        const handlePrev = () => {
            const currentIndex = getCurrentStepIndex();
            if (currentIndex > 0) {
                currentStep.value = BULK_EDIT_STEPS_LIST[currentIndex - 1];
            }
        };
        const handleConfirm = () => __awaiter(this, void 0, void 0, function* () {
            if (!canConfirm.value)
                return;
            currentStep.value = BULK_EDIT_STEPS.LOADING;
            try {
                // Build request
                bulkEditService.formData.value.columns = editableColumns.value;
                if (!props.period)
                    throw new Error("Periodo no especificado");
                const request = bulkEditService.buildBulkEditRequest(bulkEditService.formData.value, props.period);
                // Submit
                const response = yield sendChangeRequest(request);
                result.value = response;
                currentStep.value = BULK_EDIT_STEPS.RESULT;
            }
            catch (error) {
                console.error(">>Bulk edit error:", error);
                result.value = {
                    success: false,
                    affectedRows: 0,
                    message: "Error al comunicarse con el servidor",
                    errors: [error instanceof Error ? error.message : String(error)],
                };
                currentStep.value = BULK_EDIT_STEPS.RESULT;
            }
        });
        const handleRetry = () => {
            currentStep.value = BULK_EDIT_STEPS.CONFIRMATION;
        };
        const handleBackToEdit = () => {
            currentStep.value = BULK_EDIT_STEPS.EDIT_FIELDS;
        };
        const handleCancel = () => {
            var _a, _b, _c, _d;
            const shouldReload = currentStep.value === BULK_EDIT_STEPS.RESULT && ((_a = result.value) === null || _a === void 0 ? void 0 : _a.success);
            (_b = dialogRef.value) === null || _b === void 0 ? void 0 : _b.close();
            if (shouldReload) {
                // Signal that data should be reloaded
                (_c = dialogRef.value) === null || _c === void 0 ? void 0 : _c.accept(true);
            }
            else {
                (_d = dialogRef.value) === null || _d === void 0 ? void 0 : _d.cancel();
            }
        };
        // Expose methods
        __expose({
            open,
        });
        const __returned__ = { props, dialogRef, currentStep, result, stepsForStepper, bulkEditService, editableColumns, distributorOptions, objectiveOptions, selectedObjective, selectedObjectiveName, expectedRowCount, delegacionLineCount, isDelegacionValid, hasValidationErrors, fieldsBeingModified, activeColumns, previewData, previewErrors, totalAffectedFields, getCurrentStepIndex, isNavigableStep, showStepper, showPrevButton, showCancelButton, showNextButton, showConfirmButton, showRetryButton, showBackToEditButton, canProceedToNext, canConfirm, isStepCompleted, open, handleNext, handlePrev, handleConfirm, handleRetry, handleBackToEdit, handleCancel, Dialog, Button, Select, get StepIndicator() { return StepIndicator; }, get TriangleAlertIcon() { return TriangleAlertIcon; }, get BULK_EDIT_STEPS() { return BULK_EDIT_STEPS; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
